// src/api/specialtyUI.js
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/ui/specialties`;

export async function fetchSpecialties() {
  const response = await axios.get(BASE_URL);
  return response.data;
}

export async function createSpecialty(data) {
  const response = await axios.post(BASE_URL, data);
  return response.data;
}

export async function updateSpecialty(id, data) {
  const response = await axios.put(`${BASE_URL}/${id}`, data);
  return response.data;
}

export async function deleteSpecialty(id) {
  const response = await axios.delete(`${BASE_URL}/${id}`);
  return response.data;
}
